/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-to-do-list-no-rows-overlay',
  styleUrls: ['to-do-list-no-rows-overlay.component.scss'],
  templateUrl: 'to-do-list-no-rows-overlay.component.html',
})
export class ToDoListNoRowsOverlayComponent {
  @Input() hasSelectedUser: boolean;
}
